var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExtensaoPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_774684_pdf_document_extension_file_format_icon",
    "data-name": "774684_pdf_document_extension_file_format_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.386,
    height: 22.709,
    viewBox: "0 0 17.386 22.709",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_64",
    "data-name": "Caminho 64",
    d: "M17.386,5.976v14.94a1.8,1.8,0,0,1-1.8,1.793H1.8A1.8,1.8,0,0,1,0,20.916V1.793A1.8,1.8,0,0,1,1.8,0h9.592Z",
    fill: "#cb0606",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_65",
    "data-name": "Caminho 65",
    d: "M37.392,5.641v.744h-4.9c-1.015,0-1.483-.823-1.483-1.838V0h.742Z",
    transform: "translate(-20.006)",
    fill: "#fb8d8d",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_66",
    "data-name": "Caminho 66",
    d: "M20.117,32.588a1.425,1.425,0,0,0-.447-.077.445.445,0,0,0-.337.1.537.537,0,0,0-.092.358V33.3h.686v.658h-.686v2.709H18.41V33.956h-.428V33.3h.428V32.97a1.163,1.163,0,0,1,.311-.905,1.361,1.361,0,0,1,.935-.279,2.618,2.618,0,0,1,.622.08Zm-3.481,3.749a2.075,2.075,0,0,1-.49.312,1.417,1.417,0,0,1-.586.115,1.138,1.138,0,0,1-.976-.459,2.154,2.154,0,0,1-.338-1.3,2.114,2.114,0,0,1,.372-1.332,1.252,1.252,0,0,1,1.045-.475,1.342,1.342,0,0,1,.489.1,1.31,1.31,0,0,1,.415.249V31.885H17.4v4.779h-.763Zm-.068-2.106a1.333,1.333,0,0,0-.327-.21.931.931,0,0,0-.4-.091.628.628,0,0,0-.538.287,1.325,1.325,0,0,0-.2.778,1.479,1.479,0,0,0,.166.761.557.557,0,0,0,.514.276,1.033,1.033,0,0,0,.42-.095,1.346,1.346,0,0,0,.365-.233Zm-3.552,2.314a1.225,1.225,0,0,1-.731.218,1.393,1.393,0,0,1-.956-.35v1.518H10.5V33.3h.766v.33a2,2,0,0,1,.488-.313,1.432,1.432,0,0,1,.588-.114,1.141,1.141,0,0,1,.976.45,2.162,2.162,0,0,1,.335,1.306,2.578,2.578,0,0,1-.164.957A1.373,1.373,0,0,1,13.016,36.546ZM12.623,34.2a.56.56,0,0,0-.509-.274,1.032,1.032,0,0,0-.417.094,1.393,1.393,0,0,0-.369.233v1.473a1.323,1.323,0,0,0,.327.21.932.932,0,0,0,.4.092.62.62,0,0,0,.539-.291,1.348,1.348,0,0,0,.2-.772A1.452,1.452,0,0,0,12.623,34.2Z",
    transform: "translate(-6.773 -20.508)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtensaoPdf);
export default __webpack_public_path__ + "static/media/extensao-pdf.6fe6627faec73a34eed9e5363eb9b7f0.svg";
export { ForwardRef as ReactComponent };